module.exports = __webpack_public_path__ + "media/assets/icons/ic-trash-85d7b004e2b941d39822cb08157db1d5.svg";